module.exports = __webpack_public_path__ + "static/img/Patrick-Dangerfield.ef63ae1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Patrick-Dangerfield.jpg
// module id = G85y
// module chunks = 0